module.exports = __webpack_public_path__ + "img/53237962000125.10f83dd4.png";